import { Link } from "gatsby"
import { func, node, string } from "prop-types"
import React, { forwardRef, useEffect, useState } from "react"
import Spinner from "react-bootstrap/Spinner"

import styles from "./Button.module.scss"

const ModifiedButton = forwardRef(
  (
    {
      children,
      href,
      onClick,
      variant = "primary",
      state,
      size = "large",
      icon,
      expanded,
      linkTarget = "_self",
      disabled,
      type = "button",
      internalLink,
      anchorLink,
      submitting,
      wrap,
    },
    ref
  ) => {
    const [anchorTarget, setAnchorTarget] = useState(null)

    const camelCase = require("camelcase")

    useEffect(() => {
      if (anchorLink && href && document) {
        setAnchorTarget(document.getElementById(href.substring(1)))
      }
    }, [anchorLink, href])

    const handleClick = (event) => {
      event.preventDefault()
      if (anchorTarget && typeof window !== "undefined") {
        let anchorTargetOffset = (anchorTarget.scrollTop -= 150)
        const y =
          anchorTarget.getBoundingClientRect().top +
          window.pageYOffset +
          anchorTargetOffset
        window.scrollTo({ top: y, behavior: "smooth" })
      }
    }

    if (anchorLink && href) {
      return (
        <button
          className={`${styles.btn} ${styles[camelCase("" + variant)]} ${
            styles[camelCase("" + size)]
          } ${styles[camelCase("" + state)]} ${styles[camelCase("" + icon)]} ${
            wrap ? styles.textWrap : styles.textNoWrap
          }`}
          ref={ref}
          type={type}
          disabled={disabled}
          onClick={handleClick}
        >
          {children}
        </button>
      )
    } else if (internalLink) {
      return (
        <Link
          className={`${styles.btn} ${styles[camelCase("" + variant)]} ${
            styles[camelCase("" + size)]
          } ${styles[camelCase("" + state)]} ${styles[camelCase("" + icon)]} ${
            wrap ? styles.textWrap : styles.textNoWrap
          } btn ${variant === "tab" ? "" : "btn-primary"}`}
          to={href}
          ref={ref}
          variant={variant}
        >
          {children}
        </Link>
      )
    } else if (href) {
      return (
        <a
          className={`btn ${variant === "tab" ? "" : "btn-primary"} ${
            styles.btn
          } ${styles[camelCase("" + variant)]} ${
            styles[camelCase("" + size)]
          } ${styles[camelCase("" + state)]} ${styles[camelCase("" + icon)]} ${
            wrap ? styles.textWrap : styles.textNoWrap
          }`}
          href={href}
          target={linkTarget}
          {...(linkTarget === "_blank" ? { rel: "noopener noreferrer" } : {})}
          ref={ref}
        >
          {children}
        </a>
      )
    } else {
      return (
        <button
          className={`${styles.btn} ${styles[camelCase("" + variant)]} ${
            styles[camelCase("" + size)]
          } ${wrap ? styles.textWrap : styles.textNoWrap} ${
            styles[camelCase("" + state)]
          } ${styles[camelCase("" + icon)]} ${submitting && styles.submitting}`}
          ref={ref}
          type={type}
          {...((expanded === true || expanded === false) && {
            "aria-expanded": expanded,
          })}
          disabled={disabled}
          onClick={onClick}
        >
          <>
            {submitting && (
              <Spinner
                as="span"
                animation="border"
                role="status"
                aria-hidden="true"
              />
            )}
            {children}
          </>
        </button>
      )
    }
  }
)

ModifiedButton.propTypes = {
  children: node,
  href: string,
  onClick: func,
  variant: string,
}

export default ModifiedButton
